import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../components/Logo';
import { adminLogin, adminMe } from '../../api';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = 'Admin Login | GOBRA';
    adminMe().then(() => navigate('/admin')).catch(() => {});
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await adminLogin(email, password);
      navigate('/admin');
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-4 bg-gobra-slate">
      <div className="w-full max-w-md bg-white rounded-2xl p-8 shadow-2xl">
        <div className="flex justify-center mb-6"><Logo variant="dark" /></div>
        <h1 className="font-title text-2xl font-bold text-gobra-slate text-center mb-6">Admin Panel</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-gobra-slate">Email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" />
          </div>
          <div>
            <Label className="text-gobra-slate">Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1" />
          </div>
          {error && <p className="text-destructive text-sm">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full bg-gobra-green hover:bg-gobra-green-dark text-white rounded-full py-6">
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>
      </div>
    </main>
  );
};

export default AdminLogin;
